
















import { ApexChartOptions, BarChartOptions } from '@/api/model/ApexChartOptions';
import { Component, Prop, Vue, Watch, Mixins, Emit } from 'vue-property-decorator';

@Component({
    components: {},
})
export default class FactorImportanceChart extends Vue {
    /**
     * Reset chart
     */
    @Prop({ type: Boolean, default: false })
    public resetChart!: boolean;

    @Prop({
        type: Object,
        default: () => ({
            data: [],
            title: '',
            categories: [],
        }),
    })
    chartData!: any;

    /**
     * Chart options(If override default options)
     */
    @Prop({ type: Number, default: 600 })
    public height!: number;

    /**
     * Chart options(If override default options)
     */
    @Prop({ type: Number, default: 800 })
    public width!: number;

    @Prop({ type: Boolean, default: true })
    isHorizontal!: boolean;

    // @Prop({ type: Boolean, default: true})
    // isDonut!: boolean;

    /**
     * initialize
     */
    mounted() {}

    get chartOptions() {
        let chartOptions: BarChartOptions = {
            chart: {
                type: 'bar',
                redrawOnWindowResize: false,
                redrawOnParentResize: false,
                offsetY: 0,
                offsetX: 0,
                toolbar: {
                    show: false,
                    offsetX: 0,
                    offsetY: 0,
                },
            },
            plotOptions: {
                bar: {
                    horizontal: this.isHorizontal,
                    dataLabels: {
                        position: 'center', // top, center, bottom
                    },
                    // endingShape: 'round', // flat, rounded // deprecated
                    columnWidth: '50%',
                    barHeight: '50%',
                },
            },
            dataLabels: {
                enabled: false,
                formatter: function (val: any) {
                    return String(val ? val.toFixed(0) : '');
                },
                offsetX: 0,
                offsetY: 0,
                style: {
                    fontSize: '14px',
                    colors: ['#ffffff'],
                },
            },
            xaxis: {
                tickAmount: 10,
                type: 'category',
                categories: this.chartData.categories.slice(0, 20),
                position: 'bottom',
                title: {
                    text: !this.isHorizontal ? 'Factors' : 'Relative Importance',
                    style: {
                        color: '#0A4B71',
                        fontSize: '16px',
                        fontFamily: 'Helvetica, Arial, sans-serif',
                        fontWeight: 600,
                    },
                },
                labels: {
                    show: true,
                    style: {
                        colors: '#0A4B71',
                        fontSize: '12px',
                        fontFamily: 'Helvetica, Arial, sans-serif',
                        fontWeight: 400,
                        cssClass: 'apexcharts-xaxis-label',
                    },
                    formatter: function (data: any) {
                        if (typeof data == 'string') {
                            return data.length >= 20 ? data.substring(0, 17) + '...' : data;
                        } else if (typeof data == 'number') {
                            return data.toFixed(0);
                        }
                    },
                },
                axisBorder: {
                    show: true,
                },
                axisTicks: {
                    show: false,
                },
                crosshairs: {
                    fill: {
                        type: 'gradient',
                        gradient: {
                            colorFrom: '#D8E3F0',
                            colorTo: '#BED1E6',
                            stops: [0, 100],
                            opacityFrom: 0.4,
                            opacityTo: 0.5,
                        },
                    },
                },
                tooltip: {
                    enabled: false,
                },
            },
            yaxis: {
                tickAmount: 10,
                labels: {
                    show: true,
                    maxWidth: 400,
                    minWidth: this.isHorizontal ? this.getYLabelSize() : 80,
                    style: {
                        colors: '#0A4B71',
                        fontSize: '14px',
                        fontFamily: 'Nunito, Helvetica, Arial, sans-serif',
                        fontWeight: 400,
                        cssClass: 'apexcharts-xaxis-label',
                    },
                    offsetX: this.isHorizontal ? 0 : -12,
                    offsetY: 0,
                    formatter: function (data: any) {
                        if (typeof data == 'string') {
                            return data.length >= 30 ? data.substring(0, 27) + '...' : data;
                        } else if (typeof data == 'number') {
                            return data.toFixed(0);
                        }
                    },
                },
                axisBorder: {
                    show: true,
                },
                axisTicks: {
                    show: true,
                },
                title: {
                    text: this.isHorizontal ? 'Factors' : 'Relative Importance',
                    style: {
                        color: '#0A4B71',
                        fontSize: '16px',
                        fontFamily: 'Helvetica, Arial, sans-serif',
                        fontWeight: 600,
                    },
                },
            },
            title: {
                floating: true,
                align: 'center',
                style: {
                    color: '#0A4B71',
                },
            },
            tooltip: {
                enabled: true,
            },
            grid: {
                show: true,
                borderColor: '#0A4B7166',
                strokeDashArray: 0,
                position: 'back',
                xaxis: {
                    lines: {
                        show: this.isHorizontal,
                    },
                },
                yaxis: {
                    lines: {
                        show: !this.isHorizontal,
                    },
                },
                row: {
                    colors: undefined,
                    opacity: 0.5,
                },
                column: {
                    colors: undefined,
                    opacity: 0.5,
                },
                padding: {
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0,
                },
            },
        };
        return chartOptions;
    }

    /**
     * Default Options
     */
    private applyDefaultOptions() {
        return;
    }

    /**
     * onClick
     */
    private onClick(event?: MouseEvent | undefined, activeElements?: {}[] | undefined): any {}

    /**
     * Reset chart position
     */
    @Watch('')
    private resetChartPosition() {}

    /**
     * get maximum x axis value for the bar chart
     */
    private getXaxisMax() {
        return (Math.floor(this.chartData.data[0] / 10) + 1) * 10;
    }

    private getMaxCategoriesLength() {
        let max = 0;
        if (this.chartData.categories && this.chartData.categories.length > 0) {
            this.chartData.categories.forEach((e: string) => {
                if (e.length > max) {
                    max = e.length;
                }
            });
        } else {
            max = 5;
        }
        return max;
    }
    private getYLabelSize() {
        let max = this.getMaxCategoriesLength();
        if (max > 30) {
            max = 30;
        }
        return 50 + 8 * max;
    }

    /**
     * click a chart element
     */
    @Emit('click-chart-element')
    public clickChartElement(element: any) {
        return element;
    }
}
